<script setup lang="ts">
import { ref } from 'vue'
import { useOpsStore } from '@/stores/ops'
import { useCommsStore } from '@/stores/comms'

defineProps<{ incidentId: string }>()

const opsStore = useOpsStore()
const commsStore = useCommsStore()

const collapsed = ref(false)

function toggleCollapsed() {
  collapsed.value = !collapsed.value
}

const ASSIGNMENT_COLORS: Record<string, string> = {
  Command: 'bg-primary/10 text-primary',
  Tactical: 'bg-green-500/10 text-green-700 dark:text-green-400',
  'Air-to-Ground': 'bg-violet-500/10 text-violet-700 dark:text-violet-400',
}
</script>

<template>
  <div class="bg-surface border border-border rounded-lg px-4 py-2">
    <button class="flex items-center justify-between w-full mb-3" @click="toggleCollapsed">
      <p class="text-[10px] font-label uppercase tracking-widest text-outline">Comms</p>
      <span
        class="material-symbols-outlined text-[14px] text-outline transition-transform"
        :class="collapsed ? '' : 'rotate-180'"
      >expand_more</span>
    </button>

    <template v-if="!collapsed">
      <!-- Radio Channels -->
      <div class="mb-3">
        <p class="text-[9px] font-label uppercase tracking-widest text-outline/70 mb-1.5">Radio Channels</p>

        <div v-if="commsStore.isLoading" class="flex items-center gap-1.5 text-outline">
          <div class="w-3 h-3 border border-outline/40 border-t-outline animate-spin rounded-full" />
          <span class="font-mono text-[10px]">Loading…</span>
        </div>

        <div v-else-if="commsStore.channels.length" class="flex flex-col gap-1">
          <div
            v-for="channel in commsStore.channels"
            :key="channel.channel_id"
            class="flex items-center justify-between gap-2"
          >
            <span class="font-mono text-xs text-on-surface truncate">{{ channel.name }}</span>
            <span
              class="text-[9px] font-mono px-1.5 py-0.5 rounded shrink-0"
              :class="ASSIGNMENT_COLORS[channel.assignment] ?? 'bg-surface-container-high text-outline'"
            >{{ channel.assignment }}</span>
          </div>
        </div>

        <p v-else class="font-mono text-[10px] text-outline/50">No channels configured</p>
      </div>

      <!-- ICP Phone -->
      <div>
        <p class="text-[9px] font-label uppercase tracking-widest text-outline/70 mb-1">ICP Phone</p>
        <p
          v-if="opsStore.selectedOp?.contact_phone"
          class="font-mono text-xs text-on-surface"
        >{{ opsStore.selectedOp.contact_phone }}</p>
        <p v-else class="font-mono text-xs text-outline/50">—</p>
      </div>
    </template>
  </div>
</template>
